import React from 'react';
import './StickyBookButton.css';

interface StickyBookButtonProps {
  onClick: () => void;
}

export const StickyBookButton: React.FC<StickyBookButtonProps> = ({ onClick }) => {
  return (
    <button className="sticky-book-btn" onClick={onClick}>
      <span>Get in touch</span>
    </button>
  );
};